import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { DeviceImageConstants } from '../../constants/device-image.constants';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-image',
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.scss'],
    standalone: false
})
export class ImageComponent {
  @Input() src: string;
  @Input() alt: string;
  @Input() height: number;
  @Input() isReducedHeight: boolean;

  onError() {
    this.src = DeviceImageConstants.DEFAULT_IMAGE;
  }
}
